module.exports = __webpack_public_path__ + "static/media/foul-play-social-share.ec84f252.jpg";